function productRatingFitReview() {
  const root = document.getElementById("product-fit-review")
  const disclaimerRoot = document.getElementById("product-fit-disclaimer")
  const disclaimerContent = disclaimerRoot?.querySelector("[data-fit-disclaimer-content]")
  const hideDisclaimer = () => {
    if (!disclaimerRoot) return
    disclaimerRoot.classList.add("hidden")
    if (disclaimerContent) disclaimerContent.innerHTML = ""
  }
  const showDisclaimer = (type) => {
    if (!disclaimerRoot || !disclaimerContent) return

    const template = disclaimerRoot.querySelector(`[data-fit-disclaimer-template="${type}"]`)
    if (!template || !template.innerHTML.trim()) {
      hideDisclaimer()
      return
    }

    disclaimerContent.innerHTML = template.innerHTML
    disclaimerRoot.classList.remove("hidden")
  }

  if (!root) return

  if (!root.querySelector(".okeReviews")) {
    hideDisclaimer()
    return
  }

  const sizeBar = root.querySelector(".oke-w-header-content .oke-barBlocks--centered")

  if (sizeBar) {
    const percentEl = root.querySelector(".oke-w-header-content .oke-attrBar-title .oke-a11yText")
    const percentageText = percentEl ? percentEl.innerText : ""

    if (percentageText.includes("0.0")) {
      sizeBar.querySelector(".oke-barBlocks-bg-shading")?.style.setProperty("min-width", "30px", "important")
      sizeBar.querySelector(".oke-barBlocks-bg-shading")?.style.setProperty("transform", "translateX(-13px)", "important")
      sizeBar.querySelector(".oke-barBlocks-bg-centerLine")?.style.setProperty("background", "transparent", "important")
    }
  }

  const countEl = root.querySelector(".oke-w-navBar-item-count")
  const labelEl = root.querySelector(".fit-count")

  if (!countEl || !labelEl) {
    hideDisclaimer()
    return
  }

  const count = Number(countEl.innerText.replace(/,/g, ""))
  labelEl.innerText = `${count.toLocaleString()} Review${count > 1 ? "s" : ""}`

  if (count < 10) {
    hideDisclaimer()
    return
  }

  const okendoScript = root.querySelector("[data-oke-metafield-data]")
  const shadingBars = root.querySelectorAll(".oke-w-barAttributes--stacked .oke-barBlocks-bg-shading")

  if (okendoScript && shadingBars.length) {
    try {
      const jsonData = JSON.parse(okendoScript.textContent || "{}")
      const attributeRatingsValue = jsonData?.reviewAggregate?.attributeRatings?.[0]?.value

      if (typeof attributeRatingsValue === "number") {
        let marginLeft = null
        let disclaimerType = null

        if (attributeRatingsValue > -0.15 && attributeRatingsValue <= 0.15) {
          marginLeft = "calc( 50% - 15px)"
        } else if (attributeRatingsValue > -0.5 && attributeRatingsValue <= -0.15) {
          marginLeft = "calc( 25% - 15px)"
          disclaimerType = "small"
        } else if (attributeRatingsValue > -1 && attributeRatingsValue <= -0.5) {
          marginLeft = "0"
          disclaimerType = "small"
        } else if (attributeRatingsValue > 0.15 && attributeRatingsValue <= 0.5) {
          marginLeft = "calc( 75% - 15px)"
          disclaimerType = "big"
        } else if (attributeRatingsValue > 0.5 && attributeRatingsValue <= 1) {
          marginLeft = "calc( 100% - 30px)"
          disclaimerType = "big"
        }

        if (marginLeft !== null) {
          shadingBars.forEach((el) => el.style.setProperty("margin-left", marginLeft, "important"))
        }

        shadingBars.forEach((el) => el.style.setProperty("transform", "none", "important"))

        if (disclaimerType) {
          showDisclaimer(disclaimerType)
        } else {
          hideDisclaimer()
        }
      } else {
        hideDisclaimer()
      }
    } catch (e) {
      hideDisclaimer()
      console.error("Error parsing JSON from data-oke-metafield-data:", e)
    }
  } else {
    hideDisclaimer()
  }

  root.classList.remove("hidden")
}

document.addEventListener("DOMContentLoaded", () => {
  setTimeout(productRatingFitReview, 500)
})
